// Dev-only warnings; silent in the live build.
export const warn = (...args) => { if (process.env.NODE_ENV !== "production") console.warn(...args); };
